import { useState } from "react";
import { Button, Checkbox, Modal } from "antd";
import { useSearchParams } from "react-router-dom";
import styles from "./SortModal.module.css";
import { useTranslation } from "react-i18next";

const SortModal = ({ sort_modal, set_sort_modal, sort_list }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const sort = searchParams.get("sort") || null;
  const [sortState, setSortState] = useState(sort);

  const sort_pre_handle = (sortItem, status) => {
    if (status)
      setSortState(`${sortItem.value.field}-${sortItem.value.direction}`);
    else setSortState(null);
  };

  const submit_click = () => {
    setSearchParams((prev) => {
      if (sortState) prev.set("sort", sortState);
      else prev.delete("sort");
      return prev;
    });
    set_sort_modal(false);
  };

  return (
    <Modal
      open={sort_modal}
      footer={null}
      className={styles.SortModal}
      styles={{
        body: {
          paddingTop: "30px",
        },
      }}
      onCancel={() => set_sort_modal(false)}
    >
      <div className={styles.SortModalContainer}>
        {sort_list.map((sortItem) => {
          return (
            <Checkbox
              checked={
                sortState ===
                `${sortItem.value.field}-${sortItem.value.direction}`
              }
              className={styles.CheckboxStyle}
              onChange={(event) => {
                sort_pre_handle(sortItem, event.target.checked);
              }}
            >
              {t(`home.${sortItem.label}`)}
            </Checkbox>
          );
        })}
        <div className="w-full flex center-content mt-4">
          <Button
            type="primary"
            style={{
              width: "80%",
            }}
            onClick={submit_click}
          >
            {t("common.sort")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SortModal;
